;(function($){
    /////////////////////////////////////////////////////////////////////////////////////////

    // Retina蟇ｾ蠢懊�縺溘ａ縺ｫ逕ｻ蜒上ｒ蜊雁�縺ｮ繧ｵ繧､繧ｺ縺ｫ縺吶ｋ
    $.fn.retinaImages = function() {
        this.each(function(i, element){
            var img = new Image();
            img.src = $(element).attr('src');
            img.onload = function(){
                var width = img.width;
                var height = img.height;
                if (width !== 0 || height !== 0) {
                    $(element).width(Math.floor(width / 2)).height(Math.floor(height / 2));
                }
            };
        });
        //console.log("retinaImages");
        return true;
    };


    // Retina蟇ｾ蠢懊�縺溘ａ縺ｮ繧ｹ繧ｿ繧､繝ｫ繧貞､悶☆
    $.fn.removeRetinaImagesStyle = function() {
        this.each(function(i, element){
            $(element).removeAttr('style');
        });
        //console.log("removeRetinaImagesStyle");
        return false;
    };


    // PC/繧ｹ繝槭�逕ｨ逕ｻ蜒上↓蟾ｮ縺玲崛縺医ｋ
    $.fn.setSpImages = function(spFlag) {
        this.each(function() {
            var currentSrc = $(this).attr('src');
            var replacedSrc;

            if(!spFlag) {
                replacedSrc = currentSrc.replace(/(\.gif|\.jpg|\.png|\.svg)/g, '--sp$1');
            } else {
                replacedSrc = currentSrc.replace(/--sp/g, '');
            }

            $(this).attr("src", replacedSrc);

        });
        //console.log("setSpImages");
        return false;
    };


    // 繧ｹ繝�繝ｼ繧ｹ繧ｹ繧ｯ繝ｭ繝ｼ繝ｫ
    $.fn.SmoothScroll = function() {
        var target = $(this);
        $(target).click(function() {
            var speed = 600; // 繝溘Μ遘�
            var href= $(this).attr("href");
            var target = $(href === "#" || href === "" ? 'html' : href);
            var position = target.offset().top;
            $('body,html').animate({scrollTop:position}, speed, 'swing');
            return false;
        });
    };
})(jQuery);